module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": (_vm.certificado ? _vm.certificado.tipo_certificado_nome + ' - ' + _vm.certificado.representante : ''),
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.loadingSave,
      "onSave": _vm.salvar,
      "width": "70%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-position": "top",
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('el-form-item', {
    class: _vm.error['empresa'] ? 'is-error' : '',
    attrs: {
      "label": "INSERIR NOVO VÍNCULO",
      "prop": "empresa",
      "rules": [{
        required: false,
        message: 'Campo Obrigatorio'
      } ]
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "placeholder": "Digite o nome da empresa",
      "remote-method": _vm.getEmpresa,
      "loading": _vm.loadingEmpresa,
      "value-key": "id"
    },
    on: {
      "change": function($event) {
        return _vm.salvar('ruleForm')
      }
    },
    model: {
      value: (_vm.formData.empresa),
      callback: function($$v) {
        _vm.$set(_vm.formData, "empresa", $$v)
      },
      expression: "formData.empresa"
    }
  }, _vm._l((_vm.lstEmpresa), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item,
        "label": item.nome
      }
    }, [_c('div', {
      staticClass: "col-md-12",
      staticStyle: {
        "float": "left"
      }
    }, [_c('b', [_vm._v(_vm._s(item.nome))])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12",
      staticStyle: {
        "float": "left",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v("\n                                  " + _vm._s(item.cnpj) + "\n                            ")])])
  }), 1), _vm._v(" "), (_vm.error['empresa']) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.error['empresa'][0]))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('TableView', {
    attrs: {
      "pagination": _vm.pagination,
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "loadingTable": _vm.loadingTable,
      "onRegister": null,
      "onEdit": null,
      "response": _vm.response,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getEsocialCertificado
    }
  })], 1)])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b204f48c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/esocial/certificado/vincular.vue
// module id = 1271
// module chunks = 43